import Vue from 'vue'
import Router from 'vue-router'

import Test from '@/components/test'
import Home from '@/components/home'
import ElementUI from 'element-ui'
import store from '@/store'
import Cookies from "js-cookie"
import qs from 'qs'
import {request} from '../utils/request'
import config from '../../package.json'
Vue.use(ElementUI)
Vue.use(Router)

const originalPush = Router.prototype.push
Router.prototype.push = function push (location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch(err => err)
}

// 2022/11/9 zhc 解决使用this.$router.replace时控制台爆红问题 start
const originalRepace = Router.prototype.replace;
Router.prototype.replace = function replace(location) {
    // call(); 篡改上下文    catch(); 捕获异常 ****
  return originalRepace.call(this, location).catch(err => err);
}
// 2022/11/9 zhc 解决使用this.$router.replace时控制台爆红问题 end

const router = new Router({
  mode: 'history',
  routes: [
    // 测试菜单的首页
    {
      path: '/',
      component: Home,
      redirect: '',
      meta: {
        title: '首页',
        // 需要登录验证
        requiresAuth: true
      },
      children: [
        // {
        //   path: '',
        //   name: 'index',
        //   redirect: '',
        //   component: Index,
        //   meta: {
        //     title: 'index',
        //     icon: 'fa fa-home fa-lg',
        //     index: 0,
        //     // 需要登录验证
        //     requiresAuth: true
        //   }
        // }
      ]
    },
    {
      path: '/login',
      name: 'login',
      redirect: '',
      component: resolve => {
        require(['@/components/login'], resolve);
      },
      meta: {
        title: '登录',
        loginType: 'login'
      }
    },
    // {
    //   path: '/test',
    //   name: 'test',
    //   redirect: '',
    //   component: Test,
    //   // component: resolve => {
    //   //   require(['@/components/test'], resolve);
    //   // },
    //   meta: {
    //     title: '测试',
    //     loginType: ''
    //   }
    // },
  ]
});

/**
 * 路由钩子
 * 未登录的情况，跳转登录界面，登录完成自动跳转原访问页面
 */
router.beforeEach((to, from, next) => {
  // console.log('进入beforeEach路由钩子')
  // console.log('menuRouteLoaded的值为：', store.state.app.menuRouteLoaded)
  // console.log('navTree的值为：', store.state.menu.navTree)
  console.log('curVersion',config.version)
  if (process.env.NODE_ENV === "production") {
    request({
      url: '/version/',
      method: 'get',
    }).then(res => {
      console.log('compare'+config.version + '-------' + res.data.version)
      console.log('version', res)
      if (res.data.version !== config.version) {
        location.reload()
      }
    }).catch(err => {
      console.log(err)
    })
  }

  if (to.meta.displayStatus == '2' && from.meta.displayStatus == '1' && from.meta.index) {
    store.commit('setActiveMenu', from.meta.index.toString())
  } else if (to.path == from.path && to.meta.displayStatus == '2') {
    store.commit('setActiveMenu', localStorage.activeMenu)
    localStorage.removeItem('activeMenu')
  }

  // 存储用户信息
  let userName = localStorage.getItem('user')
  let userId = localStorage.getItem('userId')
  let access_token = Cookies.get('access_token')

  // 登录状态返回到登录界面，自动跳转到主页
  if (to.matched.some(route => route.meta && route.meta.loginType === "login")) {
    if (access_token) {
      // 跳主页
      next({ path: "/", });
    }
  }

  // 判断路由中的登录验证是否开启
  if (to.matched.some(route => route.meta && route.meta.requiresAuth)) {
    if (!access_token) {
      // 没有登录信息跳转到登录页
      next({
        // 必须加name，不然this.$route获取不到信息
        name: "login",
        path: "/login",
        query: { redirect: to.fullPath }  // 'to.fullPath'跳转到登录之前页面的路径
      });
    } else {
      if (to.matched.some(route => route.meta && route.meta.title === "首页")) {
        // 进首页才加载路由
        setTimeout(() => {
          // 加载动态菜单和路由
          addDynamicMenuAndRoutes(userId, to, from)
        }, 0);
      }
      next();
    }
  } else if (to.matched.length == 0) {
    console.log("to.matched.length:", to.matched.length)
    if (!access_token) {
      // 没有登录信息跳转到登录页
      next({
        // 必须加name，不然this.$route获取不到信息
        name: "login",
        path: "/login",
        query: { redirect: to.fullPath }  // 'to.fullPath'跳转到登录之前页面的路径
      });
    } else {
      setTimeout(() => {
        // 加载动态菜单和路由
        addDynamicMenuAndRoutes(userId, to, from)
      }, 0);
      next();
    }
  } else {
    next();
  }
});

/**
* 加载动态菜单和路由
*/
function addDynamicMenuAndRoutes (userId, to, from) {
  if (store.state.app.menuRouteLoaded) {
    // console.log('动态菜单和路由已经存在.')
    // console.log('当前的动态路由：', router)
    return
  }

  // const navTreeData = findNavTree();
  // // 添加动态路由
  // let dynamicRoutes = addDynamicRoutes(navTreeData.data)
  // // 判断上次动态增加的路由是否存在，如果有，就清空
  // if (router.options.routes[0].children.length > 2) {
  //   router.options.routes[0].children.splice(2)
  // }
  // // 处理静态组件绑定路由
  // handleStaticComponent(router, dynamicRoutes)
  // router.matcher = new Router().matcher
  // router.addRoutes(router.options.routes)
  // // 保存加载状态
  // store.commit('menuRouteLoaded', true)
  // // 保存菜单树
  // store.commit('setNavTree', navTreeData.data)

  let url = '/api/NavigationMenu/getNavigationMenu'
  Vue.prototype.$http.post(
    url,
    qs.stringify({ userId: userId })
  ).then(response => {
    if (response.data.code === 200) {
      // 添加动态路由
      let dynamicRoutes = addDynamicRoutes(response.data.data)
      // 判断上次动态增加的路由是否存在，如果有，就清空
      if (router.options.routes[0].children.length > 0) {
        router.options.routes[0].children = []
      }
      // 处理静态组件绑定路由
      handleStaticComponent(router, dynamicRoutes)
      router.matcher = new Router().matcher
      router.addRoutes(router.options.routes)
      // 保存加载状态
      store.commit('menuRouteLoaded', true)
      // 保存菜单树
      store.commit('setNavTree', response.data.data)
    } else {
      console.log("获取路径失败！")
      // console.log(response.data.message)
    }
  }).catch((err) => {
    console.log(err)
  })


}

/**
 * 处理路由到本地直接指定页面组件的情况
 * 比如'代码生成'是要求直接绑定到'Generator'页面组件
 */
function handleStaticComponent (router, dynamicRoutes) {
  router.options.routes[0].children = router.options.routes[0].children.concat(dynamicRoutes)
}

/**
* 添加动态(菜单)路由
* @param {*} menuList 菜单列表
* @param {*} routes 递归创建的动态(菜单)路由
*/
function addDynamicRoutes (menuList = [], routes = []) {
  var temp = []
  for (var i = 0; i < menuList.length; i++) {
    if (menuList[i].children && menuList[i].children.length >= 1) {
      temp = temp.concat(menuList[i].children)
    } else if (menuList[i].url && /\S/.test(menuList[i].url)) {
      if (menuList[i].url === '/') {
        menuList[i].url = ''
      }
      menuList[i].url = menuList[i].url.replace(/^\//, '')
      if (menuList[i].url == 'home') {
        menuList[i].url = ''
      }
      // 创建路由配置
      var route = {
        path: menuList[i].url,
        component: null,
        name: menuList[i].name,
        meta: {
          icon: menuList[i].icon,
          index: menuList[i].id,
          displayStatus: menuList[i].displayStatus,
          requiresAuth: true,
        }
      }
      try {
        // 根据菜单URL动态加载vue组件，这里要求vue组件须按照url路径存储
        // 如url="sys/user"，则组件路径应是"@/views/sys/user.vue",否则组件加载不到
        // let array = menuList[i].url.split('/')
        // let url = ''
        // for (let i = 0; i < array.length; i++) {
        //   url += array[i].substring(0, 1).toUpperCase() + array[i].substring(1) + '/'
        // }
        // url = url.substring(0, url.length - 1)

        let component = menuList[i].component
        route['component'] = resolve => require([`@/${component}`], resolve)
      } catch (e) { }
      routes.push(route)
    }
  }
  if (temp.length >= 1) {
    addDynamicRoutes(temp, routes)
  } else {
    // console.log('动态路由加载...')
    // console.log(routes)
    // console.log('动态路由加载完成.')
  }
  return routes
}

/**
* 测试用获取菜单树
*/
// function findNavTree () {
//   const navTreeData = {
//     "code": 200,
//     "msg": null,
//     "data": [{
//       "id": 1,
//       "createBy": null,
//       "createTime": null,
//       "lastUpdateBy": null,
//       "lastUpdateTime": null,
//       "parentId": 0,
//       "name": "主页",
//       "url": "/",
//       "perms": null,
//       "type": 0,
//       "icon": "el-icon-setting",
//       "orderNum": 0,
//       "delFlag": 0,
//       "parentName": null,
//       "level": 0,
//     }, {
//       "id": 43,
//       "createBy": "admin",
//       "createTime": "2018-12-27T02:57:29.000+0000",
//       "lastUpdateBy": "admin",
//       "lastUpdateTime": "2018-12-27T03:02:26.000+0000",
//       "parentId": 0,
//       "name": "使用监控",
//       "url": "",
//       "perms": "",
//       "type": 0,
//       "icon": "el-icon-info",
//       "orderNum": 1,
//       "delFlag": 0,
//       "parentName": null,
//       "level": 0,
//       "children": [{
//         "id": 6,
//         "createBy": null,
//         "createTime": null,
//         "lastUpdateBy": "admin",
//         "lastUpdateTime": "2018-12-27T03:03:45.000+0000",
//         "parentId": 43,
//         "name": "个人用户注册统计",
//         "url": "/sys/data",
//         "perms": null,
//         "type": 1,
//         "icon": "el-icon-warning",
//         "orderNum": 0,
//         "delFlag": 0,
//         "parentName": "系统监控",
//         "level": 1,
//         "children": []
//       }, {
//         "id": 38,
//         "createBy": "admin",
//         "createTime": "2018-11-02T12:02:15.000+0000",
//         "lastUpdateBy": "admin",
//         "lastUpdateTime": "2018-12-27T03:03:53.000+0000",
//         "parentId": 43,
//         "name": "公司/机构注册统计",
//         "url": "/sys/service",
//         "perms": "",
//         "type": 1,
//         "icon": "el-icon-view",
//         "orderNum": 1,
//         "delFlag": 0,
//         "parentName": "系统监控",
//         "level": 1,
//         "children": []
//       }]
//     }, {
//       "id": 35,
//       "createBy": null,
//       "createTime": null,
//       "lastUpdateBy": "admin",
//       "lastUpdateTime": "2018-12-27T03:04:18.000+0000",
//       "parentId": 0,
//       "name": "客户信息库",
//       "url": "/sys/document",
//       "perms": null,
//       "type": 1,
//       "icon": "el-icon-document",
//       "orderNum": 3,
//       "delFlag": 0,
//       "parentName": null,
//       "level": 0,
//       "children": []
//     }, {
//       "id": 42,
//       "createBy": "admin",
//       "createTime": "2018-11-15T06:39:30.000+0000",
//       "lastUpdateBy": "admin",
//       "lastUpdateTime": "2018-11-15T06:56:18.000+0000",
//       "parentId": 0,
//       "name": "绿夹克讲堂",
//       "url": "/sys/generator",
//       "perms": "",
//       "type": 1,
//       "icon": "el-icon-star-on",
//       "orderNum": 5,
//       "delFlag": 0,
//       "parentName": null,
//       "level": 0,
//       "children": []
//     }]
//   }
//   return navTreeData;
// }

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js